import isMobileDevice from './device.js';

/** 培训聊天默认入口：移动端学员端 chatPXM，桌面端 chatPX。 */
export function getDefaultChatEntryPath() {
  return isMobileDevice() ? '/chatPXM' : '/chatPX';
}

export function getDefaultChatEntryUrl() {
  if (typeof window === 'undefined') {
    return '/chatPXM';
  }
  return `${window.location.origin}${getDefaultChatEntryPath()}`;
}
